import { defineMessages } from 'react-intl';

export const rateSearchInputMessages = defineMessages({
  searchAriaLabel: {
    defaultMessage: 'Search carriers',
    id: 'dVT3D1',
    description: 'Aria label for the icon button that opens the freight rate carrier search input',
  },
  searchPlaceholder: {
    defaultMessage: 'Search',
    id: 'eXtKvw',
    description: 'Placeholder for the freight rate carrier search input',
  },
});
